module.exports = __webpack_public_path__ + "static/media/PartnerTeamViewerLogo.ea1050b9.png";